import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { buildBaseCommerceAPIRequest, } from '../common/base-commerce-api-request-builder.js';
import { productEnrichmentDefinition } from './product-enrichment.js';
export const registerProductEnrichmentOptions = createAction('commerce/productEnrichment/registerOptions');
const buildProductEnrichmentBadgesRequest = (payload, state, navigatorContext) => {
    const baseRequest = buildBaseCommerceAPIRequest(state, navigatorContext);
    return {
        ...baseRequest,
        context: {
            ...baseRequest.context,
            ...(payload.productId ? { product: { productId: payload.productId } } : {}),
        },
        placementIds: payload.placementIds,
    };
};
export const fetchBadges = createAsyncThunk('commerce/productEnrichment/fetchBadges', async (payload, { getState, rejectWithValue, extra: { apiClient, navigatorContext } }) => {
    validatePayload(payload, productEnrichmentDefinition);
    const request = buildProductEnrichmentBadgesRequest(payload, getState(), navigatorContext);
    const fetched = await apiClient.getBadges(request);
    if ('error' in fetched) {
        return rejectWithValue(fetched.error);
    }
    return {
        response: fetched.success,
    };
});
